import { RequestPurposeTypeEnum } from '../../enums/RequestPurposeTypeEnum';
import { AccreditVeterinarySellRequestUnit } from '../accreditation/accredit-veterinary-sell/AccreditVeterinarySellTransaction';
import { DisposalMethod } from '../export/export-hazardous-waste/ExportHazardousWasteTransaction';
import { CitesReleaseFalconRegistrationSourceEnum } from '../release/release-falcon/GetReleaseFalconConfigurationResponse';

export interface ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  nameUr?: string;
  code?: string;
  parentId?: number;
  inspectionTemplateFileId?: string;
}

export class ClassLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  types?: TypeLkp[];
  code?: string;
}

export class DescriptionLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RequestPurposeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: RequestPurposeTypeEnum;
}

export class PackageUnitLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class PackageSizeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  unit?: MeasureUnitLkp;
  volume?: number;

  unitId?: number;
}

export class DescriptionTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class CertifiedForLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class TypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  scientificName?: string;
  code?: string;
  validateMaxQuantity?: boolean;
  maxQuantity?: number;
  unitId?: number;
  productType?: string;
  classId?: number;
}

export class FishProcessingTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class CurrencyLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class MeasureUnitLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;

  code?: string;
}

export class SafetyPeriodUnitsLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class CitesCancelReasonLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class AppendixLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class CountryLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;

  countryId?: number;

  isHighSeverity?: boolean;

  fertilizerCertificateId?: number;
  showDeclaration?: boolean;
}

export class ExportSourceLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RequestTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;

  order?: number;
}

export class ShippingMethodLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class PortLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  dutyTypeCode?: string;
}

export class ExitPortsLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class StorageConditionLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class FishingAreasLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class ProductTemperatureLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class HeatTreatmentTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;

  code?: string;
  displayNameAr?: string;
  displayNameEn?: string;
}

export class TestPurposeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}
export class SampleSourceLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class YCodeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class HCodeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class ACodeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class UnClassesLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class TransitCountryLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class DisposalMethodLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code: DisposalMethod;
}

export class DisposalMethodDetailsLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;

  code?: string;
}

export class ImportTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class GenderLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  isNeutered?: boolean;
  code?: string;
}

export class PesticideLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class FertilizersTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RegisteredFertilizerLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  securityApprovalNumber?: string;
}

export class EndUserPurposesLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export enum EndUserPurposesEnum {
  Other = 'Other',
}

export interface ExportVeterinaryAnimalsFishFeedItemType extends ILookup {
  id: number;
  idString: null;
  code: string;
  nameAr: string;
  nameUr: string;
  nameEn: string;
  participantType: null;
  isDeleted: null;
  localizedName: string;
  parentID: null;
}

export class SampleTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class MaterialLkp implements ILookup {
  id: number;
  classId: number;
  nameAr: string;
  nameEn: string;
  scientificName: string;
}

export class PurposeOfUseLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class ProductTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  parentId?: number;
}

export class ProductLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  company?: CompanyTypeLkp;
  composition?: string;
  originCountry?: CountryLkp;
  exportingCountry?: CountryLkp;
  pharmaceuticalForm?: PharmaceuticalFormLkp;
  requestUnits?: AccreditVeterinarySellRequestUnit[];
}

export class PaymentTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class AnimalGenderLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class AnimalClassLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  idString?: string;
}

export class SubjectLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class ScientificNameLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class QuantityUnitLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class AnimalLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class PharmaceuticalFormLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class HoneyBeesProductLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class AquaticFoodImportPurposeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class RegisteredProductLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class InitialClassificationLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class PackageTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RegisteredPesticideLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;

  certificateNumber: string;
  expiryDate: Date;
}

export class CompanyTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RegisteredCompanyLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class MeatTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class MeatCategoryLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class MeatStorageLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class InitiatorActionLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class CommonNameLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class CertificateLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  procedureInstance: number;
  issuanceDate: Date;
  expiryDate: Date;
}

export class FertilizerBalanceLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  typeId: number;
  fertilizerId: number;
  certificateNo: string;
  isRestricted: boolean;
}

export class PesticideTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class PesticideBalanceLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  typeId: number;
  pesticideId: number;
  certificateNo: string;
}

export class InorganicSoilKindLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class GrowingMediaKindLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class FertilizerFormLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class AuthorityOwnerLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class InitialTypeLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class ImportPurposeLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class AreaLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class SeedLKP implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
}

export class RegistrationTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class DispositionTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  classCode?: string;
  typeCode?: string;
  caseCode?: string;
}

export class RawMaterialTypesLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  classCode?: string;
  typeCode?: string;
}

export class CitesTransferTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class CitesBalanceTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class TermsAndConditionsLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class RawMaterialLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  securityApprovalNumber?: string;
}

export class ItemStateLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
}

export class SourceLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  productType?: string;
}

export class INRTypeLkp implements ILookup {
  id: number;
  nameAr: string;
  nameEn: string;
  code?: string;
  scientificName?: string;
  appendixId?: number;
  appendixNameAr?: string;
  appendixNameEn?: string;
  itemId?: number;
  relatedTypeID?: number;
  citesItemId?: number;
  unitId?: number;
  unitNameAr?: string;
  unitNameEn?: string;
}
